import { initializeApp } from "firebase/app";
import { FIREBASE_CONFIG } from "app/constants/variables";

export const firebaseApp = initializeApp(FIREBASE_CONFIG);
